"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalAccommodationMapResponseSchema = void 0;
var zod_1 = require("zod");
var product_unit_1 = require("../product-unit");
/**
 * 국내숙소 srp/plp 지도 응답 모델
 */
exports.LocalAccommodationMapResponseSchema = zod_1.z.object({
    items: zod_1.z.array(product_unit_1.ProductUnitSchema).nullish(),
    paging: zod_1.z.object({ current: zod_1.z.number(), isLast: zod_1.z.boolean(), total: zod_1.z.number() }).nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
